import { Screen } from '../../components/lease/Screen';
import { BrandHeading } from '../../components/lease/BrandHeading';
import { PrimaryButton } from '../../components/lease/PrimaryButton';

// Mockup "11b Report Sent": confirmation shown after a successful email send.
export function ReportSent({ email, onReturnToReport, onDone }) {
  return (
    <Screen>
      <header className="animate-fade-in text-center">
        <BrandHeading className="text-4xl">Report Sent</BrandHeading>
        <p className="mt-3 text-slate-600 dark:text-slate-300">
          Your report is on its way to {email}.
        </p>
      </header>

      <div className="mt-8 animate-slide-in space-y-3">
        <button
          onClick={onReturnToReport}
          className="w-full rounded-xl bg-white py-4 text-lg font-bold text-emerald-700 ring-1 ring-emerald-200 transition hover:bg-emerald-50 dark:bg-slate-800/60 dark:text-emerald-400 dark:ring-slate-700"
        >
          Back to report
        </button>

        <PrimaryButton onClick={onDone}>Done</PrimaryButton>
      </div>
    </Screen>
  );
}

export default ReportSent;
